const JOB_KEY = 'job_key'
const ACCOUNT_KEY = 'account_key'
const JOB_TYPE_KEY = 'job_type_key'

const INSTALL = 'INSTALL'
const SERVICE = 'SERVICE'

const IS_TWO_WAY_STARTED = 'is_two_way_started'
const AUTH_TOKEN = 'AUTHTOKEN'
const EMPLOYEE_NUMBER = 'employee_number'

/**
 * Manage the how session data element are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const StorageService = {
  getJob() {
    return localStorage.getItem(JOB_KEY)
  },
  saveJob(job) {
    localStorage.setItem(JOB_KEY, job)
  },
  removeJob() {
    localStorage.removeItem(JOB_KEY)
  },

  getAccount() {
    return localStorage.getItem(ACCOUNT_KEY)
  },
  saveAccount(account) {
    localStorage.setItem(ACCOUNT_KEY, account)
  },
  removeAccount() {
    localStorage.removeItem(ACCOUNT_KEY)
  },
  getJobType() {
    return localStorage.getItem(JOB_TYPE_KEY)
  },
  saveInstallJobType() {
    localStorage.setItem(JOB_TYPE_KEY, INSTALL)
  },
  saveServiceJobType() {
    localStorage.setItem(JOB_TYPE_KEY, SERVICE)
  },
  removeJobType() {
    localStorage.removeItem(JOB_TYPE_KEY)
  },
  isInstallJob() {
    return localStorage.getItem(JOB_TYPE_KEY) === INSTALL
  },
  isServiceJob() {
    return localStorage.getItem(JOB_TYPE_KEY) === SERVICE
  },
  getTwoWayTestState() {
    return localStorage.getItem(IS_TWO_WAY_STARTED)
  },
  saveTwoWayTestState() {
    localStorage.setItem(IS_TWO_WAY_STARTED, true)
  },
  removeTwoWayTestState() {
    localStorage.removeItem(IS_TWO_WAY_STARTED)
  },
  isInstallFlowWithCSNumber() {
    return this.getAccount() && this.isInstallJob()
  },
  isInstallFlowWithJobNumber() {
    return this.getJob() && this.isInstallJob()
  },
  getAuthToken() {
    return localStorage.getItem(AUTH_TOKEN)
  },
  saveAuthToken(authToken) {
    localStorage.setItem(AUTH_TOKEN, authToken)
  },
  removeAuthToken() {
    localStorage.removeItem(AUTH_TOKEN)
  },
  getEmployeeNumber() {
    return localStorage.getItem(EMPLOYEE_NUMBER)
  },
  saveEmployeeNumber(employeeNumber) {
    localStorage.setItem(EMPLOYEE_NUMBER, employeeNumber)
  },
  removeEmployeeNumber() {
    localStorage.removeItem(EMPLOYEE_NUMBER)
  },
}

export default StorageService
